import { FunctionComponent, SVGProps } from 'react';

import EntitiesIcon from '@sbu/assets.svg/src/entities.svg';
import InsightsIcon from '@sbu/assets.svg/src/insights.svg';
import SignalsIcon from '@sbu/assets.svg/src/signal.svg';

export enum EventPages {
  Insights = 'insights',
  Signals = 'signals',
  Entities = 'entities',
}

export const eventPageLabelsMap: { [key in EventPages]: string } = {
  [EventPages.Insights]: 'Insights',
  [EventPages.Signals]: 'Signals',
  [EventPages.Entities]: 'Entities',
};

export const eventPageIconsMap: {
  [key in EventPages]: FunctionComponent<SVGProps<SVGSVGElement>>;
} = {
  [EventPages.Insights]: InsightsIcon,
  [EventPages.Signals]: SignalsIcon,
  [EventPages.Entities]: EntitiesIcon,
};
